(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('MultichannelLinksController', MultichannelLinksController);

  MultichannelLinksController.$inject = ['$timeout', '$scope', '$http', '$stateParams', 'NotificationFactory', 'CompanyService', 'MultichannelLinks', 'FoundationApi', 'Upload', 'ngTableParams', '$state', 'WhatsAppWebService', 'ChatService', 'FacebookService', 'EmailService'];

  function MultichannelLinksController ($timeout, $scope, $http, $stateParams, NotificationFactory, CompanyService, MultichannelLinks, FoundationApi, Upload, ngTableParams, $state, WhatsAppWebService, ChatService, FacebookService, EmailService) {
    var vm = this;

    	var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });
    vm.shortURL = shortURL;

    WhatsAppWebService
      .all()
      .$promise
      .then(function (data) {
        vm.channels_web = data;
      })
      .catch(function (error) {
        errorHandler(error, $scope.labels.errorLoadNumbers)
      })
    ChatService
      .all()
      .$promise
      .then(function (data) {
        vm.webchats = data;
      })
      .catch(function (error) {
        errorHandler(error, $scope.labels.errorLoadNumbers)
      })
    FacebookService
      .all()
      .$promise
      .then(function (data) {
        vm.facebook_pages = data;
      })
      .catch(function (error) {
        errorHandler(error, $scope.labels.errorLoadNumbers)
      })
    EmailService
      .all()
      .$promise
      .then(function (data) {
        vm.emails = data;
      })
      .catch(function (error) {
        errorHandler(error, $scope.labels.errorLoadNumbers)
      })

    vm.linksTable = new ngTableParams({
      page: 1,
      count: 50,
      filter: vm.filters

    }, {
      counts: [25, 50, 100],
      getData: function ($defer, params) {
        MultichannelLinks
          .paged(params.url())
          .$promise
          .then(function (data) {
            params.total(data.total);
            $defer.resolve(data.result);
          }).catch(function (data) {
            errorHandler(data, $scope.labels.errorListStatus)
          })
      }
    });
    if ($stateParams.id) {
      MultichannelLinks
        .find({ id: $stateParams.id })
        .$promise
        .then(function (data) {
          vm.link = data;
        }).catch(function (data) {
          errorHandler(data, $scope.labels.errorListStatus)
        })
    }
    // NUMEROS WHATSAPP
    vm.novo = function () {
      $state.go('main.create-multichannel')
    }
    vm.editar = function (id) {
      // vm.link = whatsapp;
      $state.go('main.create-multichannel', { id: id })
    }
    vm.getFinalLink = function (hash) {
      return vm.shortURL + '/' + hash;
    }
    vm.saveLink = function (link) {
      vm.link = link;
      // vm.link.company_id = vm.company.id;

      if (vm.link.id == undefined) {
            	MultichannelLinks.create({},
            		vm.link,
            		function (data) {
            vm.link = data;
	                	// vm.links.push(vm.link);
	                	successHandler(data, $scope.labels.multLinkCreated);
            $state.go('main.create-multichannel', { id: data.id })
	            	},
	            	function (error) {
		                errorHandler(error, $scope.labels.errorListStatus)
	            });
      } else {
            	MultichannelLinks.update({
	                id: vm.link.id
	            }, vm.link,
	            function (data) {
          // vm.due_date = null;
	                successHandler(data, $scope.labels.multLinkUpdated);
          $state.go('main.create-multichannel', { id: data.id })
	            }, function (error) {
	                 errorHandler(error, $scope.labels.errorListStatus)
	            });
      }
      // FoundationApi.publish('addNumberModal', 'close');
    }
    vm.formatNumber = function (number) {
      var other = number;
      var country_code = '+' + other.substr(0, 2);
      var area_code = other.substr(2, 2);
      var number = number.substr(4);
      return country_code + ' (' + area_code + ') ' + number;
    }
    vm.destroyLink = function (link) {
      MultichannelLinks.destroy({
        id: link.id
      })
        .$promise
        .then(function (data) {
          successHandler(data, $scope.labels.linkRemoved)
          vm.linksTable.reload();
        }).catch(function (error) {
          errorHandler(error, $scope.labels.errorRemoveLink)
        })
    }
    function errorHandler (data, message) {
      var message = $scope.labels.errorTryAgain
      if (data) {
        if (data.data) {
          if (data.data.message) { message = data.data.message; }
        }
      }
      notifSet.addNotification({ title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }
    function successHandler (data, override_message) {
      var message = $scope.labels.dataSaved;
      if (override_message) {
        message = override_message
      } else {
        if (data) {
          if (data.data) {
            if (data.data.message) { message = data.data.message; }
          }
        }
      }
      notifSet.addNotification({ title: $scope.labels.success, content: message, autoclose: '3000', color: 'success' });
    }
    vm.uploadFiles = function (file, index, link) {
      if (file) {
        if (file.length) {
          var params = {};
          if (link.hash !== undefined) {
            params.hash = link.hash;
          }
          file.upload = Upload.upload({
            url: baseUrl + '/multichannel-upload',
            fields: params,
            file: file
          });
          file.upload.then(function (response) {
            $timeout(function () {
              link.payload.logo_image = response.data.url;
              vm.saveLink(link);
            });
          }, function (response) {
            errorHandler(response, $scope.labels.errorUploadPhoto)
          });
        }
      }
    };
  }
})();
